import React, { Component } from 'react'
import { Tab, Tabs } from "react-bootstrap";
import NeedHelp from '../Elements/NeedHelp';
import { getInitialRoute } from '../../../../../../utils';
import { createFeedAction } from '../../../../../../actions/addFeedActions';
import InputField from '../Elements/InputField';
import CheckBoxField from '../Elements/CheckboxField';
import SubmitFeedRequest from '../Elements/SubmitFeedRequest';

class Airbnb extends Component {
    state = {
        text: "",
        manuallyApprove: false,
        error: false,
        filterType: "Handle",
        loading:false
    }

    onSubmit = () => {
        const { text, manuallyApprove} = this.state
        const { hideAddfeed,wallId,navigation } = this.props

        if (!text || text == "") this.setState({ error: true })
        else {
            this.setState({ error: false,loading:true })

            var obj = {
                wallId: wallId,
                networkId: 23,
                moderation: manuallyApprove ? 1 : 0,
                feedType: 56,
                airbnb_page_review: text,
                filter: 56,
            }

            createFeedAction(obj,23,(feedId)=> this.setState({loading:false},()=>{ 
                if(feedId){
                    navigation(`/moderation/index/${wallId}`);
                    hideAddfeed();
                }
            }));
        }
    }

    

    componentDidMount() {
        this.props.onFilterNameChange('page url');
    }

    render() {
        const { text,manuallyApprove, error, loading} = this.state
        const { feedInfo, onBack } = this.props
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="form-body create_feed_wt">
                        <div className="tabbable-tabdrop newRadio d-flex align-items-center justify-content-between flex-wrap feeds_details personalizePopup">
                            <Tabs defaultActiveKey="Listing Url" id="AirbnbFeedTab" className="nav-tabs-line nav-tabs-bold w-100 tabDrop mb-3">
                                {feedInfo && feedInfo.length && feedInfo[0].networkTab && feedInfo[0].networkTab.length ? feedInfo[0].networkTab.map(filter => (
                                    <Tab eventKey={filter.feedtype} key={filter.filter} className="nav-link className= p-0" title={<span>{filter.feedName}</span>}>
                                        <div className="form-group">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">
                                                        <i className="fab fa-font-awesome-flag"></i>
                                                    </span>
                                                </div>
                                                <InputField name={"text"} id='airbnb_url' className={`mycheck form-control`} placeholder="Enter Airbnb Page Url" value={text} onChangeHandler={(e) => this.setState({text:e.target.value,error:false})} />
                                            </div>
                                            {error ? <span className="errorMessage required">This field is required</span> : null}
                                        </div>
                                        <div className="hideforBSearch">
                                            <div className="checkbox-inline">
                                                 <CheckBoxField isChecked={manuallyApprove} onChangeHandler={(e) => this.setState({manuallyApprove:e.target.checked})} name={"moderation"} id="checkbox_airbnb" />
                                            </div>
                                        </div>
                                    </Tab>
                                )) : null}
                            </Tabs>
                            <div className="form-actions w-100">
                                <div className="f-between flex-wrap border-top pt-3 mt-4">
                                    {getInitialRoute() === 'widget' ? 
                                    <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://player.vimeo.com/video/497245578'} supportLink={'https://taggbox.com/support/how-to-add-feeds-to-taggbox-widget/'} />
                                    :
                                    <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://vimeo.com/537160398'} supportLink={''} />
                                    }
                                    <SubmitFeedRequest loading={loading} onBack={onBack} onSubmit={this.onSubmit}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default Airbnb
